import React, { useState, useEffect } from "react";

const HtmlPopup = ({ media, onSave, onClose }) => {

    const [name, setName] = useState("");
    const [html, setHtml] = useState("");
    const [duration, setDuration] = useState(30);
    const [backgroundColor, setBackgroundColor] = useState("#FFFFFF");
    const [transparent, setTransparent] = useState(false);

    useEffect(() => {

        if (media) {
            setName(media.name);
            setHtml(media.text || "");
            setDuration(media.duration || 30);
            setBackgroundColor(media.backgroundColor || "#FFFFFF");
            setTransparent(media.transparent || false);
        }

    }, [media]);

    const handleSave = () => {

        onSave({
            id: media?.id || null,
            name,
            html,
            duration,
            backgroundColor,
            transparent
        });

    };

    return (

        <div className="popup-overlay">
            <div className="popup-content" style={{ width: "850px" }}>

                <h2>{media ? "Edit HTML" : "Add HTML"}</h2>

                <div className="form-group">
                    <label>Name</label>

                    <input
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                </div>

                <div className="form-group">
                    <label>HTML Code</label>

                    <textarea
                        rows="15"
                        className="form-control"
                        value={html}
                        onChange={(e) => setHtml(e.target.value)}
                        placeholder="<h1>Hello World</h1>"
                    />
                </div>

                <div className="form-group">
                    <label>Background Color</label>

                    <input
                        type="color"
                        className="form-control"
                        value={backgroundColor}
                        onChange={(e) => setBackgroundColor(e.target.value)}
                    />
                </div>

                <div className="form-check">
                    <input
                        type="checkbox"
                        checked={transparent}
                        onChange={(e) => setTransparent(e.target.checked)}
                    />

                    <label>&nbsp;Transparent Background</label>
                </div>

                <div className="form-group mt-3">
                    <label>Duration (seconds)</label>

                    <input
                        type="number"
                        className="form-control"
                        value={duration}
                        onChange={(e) => setDuration(Number(e.target.value))}
                    />
                </div>

                <div className="form-buttons">

                    <button
                        className="btn btn-success"
                        onClick={handleSave}>
                        Save
                    </button>

                    &nbsp;

                    <button
                        className="btn btn-primary"
                        onClick={onClose}>
                        Cancel
                    </button>

                </div>

            </div>
        </div>

    );

};

export default HtmlPopup;